<template>
  <!--
    1. 先用警报点id生成二维码，使用canvas绘制到界面上；
    2. 将页面指定节点内容转为图片，生成base64流
    3. 将base64 转化为 blob，新建下载事件，下载为图片

  -->
  <div>
    <div>
      <el-button type="primary" @click="dialogQrcodeVisible=true,reset()">重新生成</el-button>
      <el-dialog :visible.sync="dialogQrcodeVisible" v-if="dialogQrcodeVisible">
        <div><span>警报器编号:</span><el-input v-model="this.alarmManagerID" style="width: 300px;margin-top: 20px" readonly></el-input></div>
        <div><span>时间:</span><el-date-picker
          v-model="date"
          type="month"
          placeholder="选择时间"
          value-format="yyyyMM"
          style="width: 300px;margin-top: 20px"
        >
        </el-date-picker><span>该值为空，则时间为当前月</span></div>
        <div><span>批次:</span><el-input v-model="batch" style="width: 300px;margin-top: 20px"></el-input><span>该值为空，则默认值为000</span></div>
        <div><span>批次编号:</span><el-input v-model="num" style="width: 300px;margin-top: 20px"></el-input><span>该值为空，则默认累加</span></div>
        <div>
          <el-button @click="alarmIDchangeQrcode" style="margin-left:570px">生成</el-button>
          <el-button @click="dialogQrcodeVisible = false" style="margin-left: 20px">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <div style=" width: 400px; padding: 15px; background-color: white; display: flex; flex-direction: column; justify-content: center; align-items: center;" ref="imageDom" >
      <div id="qrcode" style="width: 300px; height: 300px;margin-top: 10px"></div>
      <div style="margin-top: 10px; margin-bottom: 30px;"><span style="font-size: 20px">{{pointName}}</span></div>
    </div>
    <el-button @click="clickGeneratePicture" icon="el-icon-download" style="width: 430px; margin-top: 15px;">下载</el-button>
    <!--<el-button @click="download">下载</el-button>-->
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
export default {
  name: 'QRCode',
  data(){
    return {
      alarmManagerID:'',
      link: "",
      date:'',
      batch:'',
      num:'',
      QRcode:'',//id转变后的二维码编号
      firstFlag: true,
      imgUrl:"",
      pointName:"",
      dialogQrcodeVisible:false,
      change:{
        "version": 1,
        "method": "qrcode.QRcode",
        "params": {
          "alarmPointId":"",
          "date":"",
          "batch":"",
          "num":""
          },
        "token":"#",
        "id":0
      },
      getcode:{
        "version": 1,
        "method": "qrcode.GetQRcode",
        "params": {
          "alarmPointId":"",
        },
        "token": "",
        "id":0
  }
  }
  },
  methods: {
    reset(){
      this.date = '';
      this.batch = '';
      this.num = ''
    },
    //将警报器ID转换为二维码编码
    alarmIDchangeQrcode(){
      this.change.params.alarmPointId = sessionStorage.getItem('alarmPointId');
      this.change.params.date = this.date;
      this.change.params.batch = this.batch;
      this.change.params.num = this.num;
      for (let key in this.change.params) {
        if (this.change.params[key] === "") {
          this.change.params[key] = null;
        }
      };
      this.$axios.post(this.$mainUrl,this.change).then(res=>{
        if(res.data.hasOwnProperty('result')){
          this.QRcode = res.data.result.QRcode;
          this.pointName = this.QRcode
          this.qrcode();
          this.$message({
            type: 'success',
            message: '生成二维码成功'
          })
        }else{
          this.$message({
            type: 'error',
            message: res.data.error.message
          })
        }
      })
      this.dialogQrcodeVisible = false;
    },
    getQRcode(){
      this.alarmManagerID = sessionStorage.getItem('alarmPointId')
      this.getcode.params.alarmPointId = this.alarmManagerID;
      for (let key in this.getcode.params) {
        if (this.getcode.params[key] === "") {
          this.getcode.params[key] = null;
        }
      };
      this.$axios.post(this.$mainUrl,this.getcode).then(res=>{
        if(res.data.hasOwnProperty('result')){
          this.QRcode = res.data.result.QRcode;
          this.pointName = this.QRcode
          this.qrcode();
        }else{
          this.alarmIDchangeQrcode()
        }
      })
    },
    //  生成二维码
    qrcode () {
      document.getElementById("qrcode").innerHTML = ""
      let that = this;
      let qrcode = new QRCode('qrcode', {
        width: 300,
        height: 300,        // 高度
        text:  this.QRcode,   // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      })
    },
    /**
     * 将页面指定节点内容转为图片
     * 1.拿到想要转换为图片的内容节点DOM；
     * 2.转换，拿到转换后的canvas
     * 3.转换为图片
     */
    clickGeneratePicture() {
      html2canvas(this.$refs.imageDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL("image/png");
        console.log(this.imgUrl);
        this.download();
      });
    },
    //下载图片
    download() {
      this.downloadFile(this.pointName + '.png', this.imgUrl);
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content); //new Blob([content]);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      // aLink.dispatchEvent(evt);
      //aLink.click()
      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },

  },

  // components: { QRCode },
  mounted(){
    this.getQRcode();
    // this.alarmIDchangeQrcode();
    //this.link = this.$store.state.AlarmPointStaticInfomation.result._id;
    //this.pointName = this.$store.state.pointName;
    // this.$nextTick (function () {
    //   this.qrcode();
    // })
  }
}
</script>

<style scoped>

</style>
